import { render, staticRenderFns } from "./MiniRanking.vue?vue&type=template&id=bc3fccc2&"
import script from "./MiniRanking.vue?vue&type=script&lang=js&"
export * from "./MiniRanking.vue?vue&type=script&lang=js&"
import style0 from "./MiniRanking.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MiniRanking.vue"
export default component.exports